import ax from "./ax";

// 我的代理列表
export function AuditSysRateFailNoShow(data = {}) {
  return ax({
    url: "/app/APPSysRate/AuditSysRateFailNoShow",
    method: "post",
    data
  });
}